export enum SocialNetworks {
  TIK_TOK = "TikTok",
  INSTAGRAM = "Instagram",
  LINKED_IN = "LinkedIn",
  FACEBOOK = "Facebook",
  WEBSITE = ".com",
  APP = "App",
}
